import { render } from "./SlideshowOnline.vue?vue&type=template&id=6b0ca7ed"
import script from "./SlideshowOnline.vue?vue&type=script&lang=js"
export * from "./SlideshowOnline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__